// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app--jGHqa {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  height: 100vh;\n}", "",{"version":3,"sources":["webpack://./src/taskpane/App.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;AACJ","sourcesContent":[".app {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": "app--jGHqa"
};
module.exports = ___CSS_LOADER_EXPORT___;
